import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const IEditorWorkerService = ( createDecorator('editorWorkerService'));
export { IEditorWorkerService };
